import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import axios from 'axios';
import Actions from './actions';
import { errorDuck } from '../error';
import _ from "lodash";
import moment from "moment";
import * as UTIL from '../../util';
import { apiUtil } from '../../util';
import { getSessionStorageKey } from '../../util/sessionStorage';
var Creators = Actions.Creators;
var requestAddWishlist = Creators.requestAdd;
var receiveAddWishlist = Creators.recieveAdd;
var requestRemoveWishlist = Creators.requestRemove;
var receiveRemoveWishlist = Creators.recieveRemove;
var receiveGet = Creators.receiveGet;
var clearWishlist = Creators.clear;
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;

function getWishlist(state) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var _location$location, _account$aadResponse;

      var account, location, url, token;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              account = getSessionStorageKey("account");
              location = getSessionStorageKey("cbLocation");
              url = apiUtil.API.getWishlist.replace('{storeId}', store || (location === null || location === void 0 ? void 0 : (_location$location = location.location) === null || _location$location === void 0 ? void 0 : _location$location.olo_unique_name));
              token = account === null || account === void 0 ? void 0 : (_account$aadResponse = account.aadResponse) === null || _account$aadResponse === void 0 ? void 0 : _account$aadResponse.jwtIdToken;

              if (!token) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", UTIL.apiUtil.fetchGet(url, token).then(function (res) {
                dispatch(receiveGet(res));
              }).catch(function (err) {
                console.log('Eror on wishlist request: ', err);
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function addToWishlist(productId, state) {
  return function (dispatch) {
    var _state$account, _state$account$aadRes;

    dispatch(requestAddWishlist());
    var token = (_state$account = state.account) === null || _state$account === void 0 ? void 0 : (_state$account$aadRes = _state$account.aadResponse) === null || _state$account$aadRes === void 0 ? void 0 : _state$account$aadRes.jwtIdToken;
    return UTIL.apiUtil.fetchPost(apiUtil.API.addWishlist, {
      "ProductId": productId
    }, token).then(function () {
      dispatch(receiveAddWishlist());
      dispatch(getWishlist(state));
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

function removeFromWishlist(productId, state) {
  return function (dispatch) {
    var _state$account2, _state$account2$aadRe;

    dispatch(requestRemoveWishlist());
    var token = (_state$account2 = state.account) === null || _state$account2 === void 0 ? void 0 : (_state$account2$aadRe = _state$account2.aadResponse) === null || _state$account2$aadRe === void 0 ? void 0 : _state$account2$aadRe.jwtIdToken;
    return UTIL.apiUtil.fetchDelete(apiUtil.API.removeWishlist, {
      "ProductId": productId
    }, token).then(function () {
      dispatch(receiveRemoveWishlist());
      dispatch(getWishlist(state));
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

var handleWishlist = function handleWishlist(productId, isAdd) {
  return function (dispatch, getState) {
    isAdd ? dispatch(addToWishlist(productId, getState())) : dispatch(removeFromWishlist(productId, getState()));
  };
};

var handleGetWishlist = function handleGetWishlist() {
  var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(getWishlist(getState(), store));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

export default {
  handleWishlist: handleWishlist,
  handleGetWishlist: handleGetWishlist,
  clearWishlist: clearWishlist
};